/**
 * The sentiment screen's registration, picked up by `../routes.ts`' glob.
 * Its path carries `$campaignId`, so it is a campaign navigation entry the
 * shell fills from the campaign on screen.
 */

import { createElement, type ReactNode } from 'react';
import { Activity } from 'lucide-react';
import { useParams } from '@tanstack/react-router';

import type { RouteBundle } from '../../routes/contract';
import { useCampaignOrganisationId } from '../../session/orgContext';
import { useTerritorySelection } from '../api/territorySelection';
import { st2 } from './messages';
import { SENTIMENT_PATH } from './paths';
import { SentimentPage } from './SentimentPage';

const CONTROL_PLANE_READ = 'control_plane.read';

function SentimentRoute(): ReactNode {
  const params = useParams({ strict: false }) as Record<string, string | undefined>;
  const tenantId = useCampaignOrganisationId();
  const selection = useTerritorySelection();
  if (tenantId === null) return null;
  return createElement(SentimentPage, {
    campaignId: params.campaignId ?? '',
    tenantId,
    ...selection,
  });
}

export const bundle: RouteBundle = {
  routes: [
    {
      path: SENTIMENT_PATH,
      element: createElement(SentimentRoute),
      requires: CONTROL_PLANE_READ,
      kind: 'data',
    },
  ],
  nav: [],
  campaignNav: [
    {
      path: SENTIMENT_PATH,
      label: () => st2('title'),
      requires: CONTROL_PLANE_READ,
      icon: Activity,
      order: 70,
      kind: 'data',
    },
  ],
};
